import axios from 'axios';

export const create = async payload => axios.post('/api/projectupdates/', payload);
export const getById = async id => axios.get(`/api/projectupdates/${id}`);
export const update = async (id, registration) => axios.patch(`/api/projectupdates/${id}`, registration);

export default {
  create,
  getById,
  update,
};